import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects via data-controller="searches" in the html
export default class extends Controller {

  static values = { url: String, page: Number }
  static targets = ["sortableList", "loadMore", "input", "form", "directions"]

  connect() {
    this.csrf = document.querySelector('meta[name="csrf-token"]').content
    this.debounceTimer = null
    this.debounceWait = 400
    document.addEventListener("searches:form", this.loadSearchesbench.bind(this));
    if (this.hasLoadMoreTarget) {
      this.loadMoreTarget.addEventListener("click", this.loadMore.bind(this))
    }
    if (this.hasFormTarget) {
      this.clearForm()
    }
    // Watch for new items added to the search list
    this.initializeListObserver()
    this.initializeSortable()

    // Close the modal after 2 seconds if the element has the class "close-modal"
    if (this.element.classList.contains("close-modal")) {
      setTimeout(() => {
        const modal = document.querySelector("[data-controller='modal']");
        const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
        modalController?.close();
      }, 2000);
    }
  }

  disconnect() {
    document.removeEventListener("searches:form", this.loadSearchesbench.bind(this));
    if (this.hasLoadMoreTarget) {
      this.loadMoreTarget.removeEventListener("click", this.loadMore.bind(this))
    }
    if (this.listObserver) this.listObserver.disconnect()
    if (this.sortable) this.sortable.destroy()
  }

  toggleDirections(event) {
    if (event.target.closest(".direction")) return

    const container = event.target.closest(".project-search-item-container")
    if (!container) return
    const projectSearchData = JSON.parse(container.getAttribute("data-project-search-comparative-ids"))
    const songInPreviousRounds = projectSearchData.previous_rounds_sv_ids.includes(event.params.songVersionId)
    const directions = container.querySelector("[data-searches-target='directions']")
    if (directions) {
      const willOpen = directions.hidden
      directions.hidden = !directions.hidden

      if (willOpen) {
        container.classList.add("is-open")
      } else {
        container.classList.remove("is-open")
      }
    }
  }


  initializeSortable() {
    if (this.hasSortableListTarget) {
      this.sortable = new Sortable(this.sortableListTarget, {
        handle: '.icon-left',
        animation: 200,
        ontouchmove: this.element.classList.add('dragging'),
        ontouchend: this.element.classList.remove('dragging'),
        onEnd: this.updateOrder.bind(this)
      })
    }
  }

  initializeListObserver() {
    this.listObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          this.initializeSortable()
        }
      })
    })
    // Start observing the ul element
    if (this.hasSortableListTarget) {
      this.listObserver.observe(this.sortableListTarget, {
        childList: true,
        subtree: false
      })
    }
  }

  updateOrder(event) {
    const { newIndex } = event
    const projectSearchId = event.item.dataset.projectSearchId
    console.log(event.item.dataset)

    fetch(`/api/v1/project_searches/sort/${projectSearchId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrf
      },
      body: JSON.stringify({
        project_search: {
          id: projectSearchId,
          position: newIndex + 1
        }
      })
    })
    .then(response => {
      if (!response.ok) {
        console.log(response)
        throw new Error('Reordering failed. See console response object.')
      }
      return response.json()
    })
    .catch(error => {
      console.error('Reordering error:', error)
    })
  }

  loadSearchesbench(event) {
    // This loads the list to add a song version to a search from the song version actions
    const { songVersionId } = event.detail;

    const modal = document.querySelector("[data-controller='modal']");
    if (modal) {
      const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal");
      const openEvent = new CustomEvent("modal:open", { detail: { size: "small" } });
      modalController?.open(openEvent);
    }

    Turbo.visit(`/searchbench/${songVersionId}`, {
      frame: "active-modal-content",
    })
  }

  clearForm() {
    this.formTarget.querySelectorAll('#term, #project-search-name, textarea').forEach(input => {
      input.value = ''
    })
  }

  loadMore(event) {
    event.preventDefault()

    const url = new URL(this.urlValue)
    url.searchParams.append("page", this.pageValue)

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": this.csrf
      }
    })
      .then(async (response) => {
        if (!response.ok) return
        const hasMore = response.headers.get("X-Has-More") === "true"
        const html = await response.text()

        Turbo.renderStreamMessage(html)

        this.pageValue++

        if (!hasMore && this.hasLoadMoreTarget) {
          this.loadMoreTarget.remove()
        }
      })
  }



  search() {
    clearTimeout(this.debounceTimer)
    const term = this.inputTarget.value
    this.debounceTimer = setTimeout(() => {
      // Add the term to the src on the: turbo_frame_tag "search-results"
      // Turbo will automatically request the api endpoint and render results
      const frame = document.getElementById("search-results")
      if (frame) {
        const url = new URL(this.element.action)
        url.searchParams.set("term", term)
        frame.src = url.toString()
      }
    }, this.debounceWait)
  }
}
